import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { ClearButton, SaveButton } from 'irmlib/components/FormControls'
import { FlexByRow, XDivider, YDivider, HalfScreen } from 'irmlib/styles'
import * as constants from 'irmlib/common/constants'
import { MainRouteSubRoutePage } from '../../AppControl/RoutePage'
import { errorToast } from '../../../common/functions'
import { useTranslation } from 'react-i18next'
import BoxTransmittalFilter from './BoxTransmittalFilter'
import ViewBoxTransmittalsData from './ViewBoxTransmittalsData'
import { getUser, persistFilters } from '../../../redux/global'
import styled from 'styled-components'
import { Label } from '../../../irmlib/src/components/Controls'
import { useLocation } from 'react-router-dom'


const PrimaryLabel = styled('div')`
 cursor: pointer;
`

const SubRouteTitle = styled.div`
  font-weight: bold;
  font-size: 18px;
  height: 60px;
  display: flex;
  align-items: center;
`

const Buttons = (props) => (
  <>
    <ClearButton arrRefs={props.arrRefs} />
    <XDivider width='10px' />
    <SaveButton arrRefs={props.arrRefs} />
  </>
)

Buttons.propTypes = {
  arrRefs: PropTypes.array,
}

const VerticalDivider = () => <YDivider height='15px' />

const ViewBoxTransmittals = (props) => {
  const location = useLocation()
  let transmitType
  if (location.state) {
    transmitType = location.state.transmittalType
  }
  const userval = getUser()
  const [transmittalType, setTransmittalType] = useState(transmitType || 'box')
  const emptyFilter = {
    status: constants.defaultSelect,
    districts: [constants.defaultSelect],
  }
  const { status, district } = persistFilters()
  const defDistricts = district?.length ? district : [userval?.district]
  const statusNavParam = status?.length ? status : [constants.transmittalStatus.pending, constants.transmittalStatus.published, constants.transmittalStatus.unapproved]

  const defaultActiveJobStatus = statusNavParam !== constants.defaultSelect
    ? statusNavParam
    : [constants.transmittalStatus.pending, constants.transmittalStatus.published, constants.transmittalStatus.unapproved]

  const [val, Setval] = React.useState({ ...emptyFilter, status: defaultActiveJobStatus, districts: defDistricts }) 
  const { t } = useTranslation()

  const getSelectedData = (data) => {
    if (data.District) {
      if (data.District.length) {
        if (data.District.length > 7) {
          errorToast({ message: t('toast.districtSelection'), title: t('toast.failedToFetch'), autoHideDuration: 3000, isBlocking: false })
        } else {
          if (data.Status) {
            if (data.Status.length) {
              Setval({ ...val, status: data.Status, districts: data.District })
            } else {
              errorToast({ message: t('toast.invalidStatus'), title: t('toast.error'), autoHideDuration: 3000, isBlocking: false })
            }
          } else {
            Setval({ ...val, districts: data.District })
          }
        }
      } else {
        errorToast({ message: t('toast.invalidDistrict'), title: t('toast.error'), autoHideDuration: 3000, isBlocking: false })
      }
    } else if (data.Status) {
      if (data.Status.length) {
        Setval({ ...val, status: data.Status })
      } else {
        errorToast({ message: t('toast.invalidStatus'), title: t('toast.error'), autoHideDuration: 3000, isBlocking: false })
      }
    }
  }

  const transmittalStatuses = [
    { value: constants.transmittalStatus.pending, label: t('transmittalTypeObj.pending') },
    { value: constants.transmittalStatus.published, label: t('jobStatusObj.submit') },
    { value: constants.transmittalStatus.processed, label: t('transmittalTypeObj.processed') },
    { value: constants.transmittalStatus.uploaded, label: t('transmittalTypeObj.uploaded') },
    { value: constants.transmittalStatus.failed, label: t('transmittalTypeObj.failed') },
    { value: constants.transmittalStatus.cancelled, label: t('transmittalTypeObj.cancelled') },
    { value: constants.transmittalStatus.unapproved, label: t('transmittalTypeObj.unapproved') }
  ]

  const TransmittalSelection = (props) => {
    return (
      <SubRouteTitle>
        <PrimaryLabel id={'activityList_button_boxDetails'} onClick={() => setTransmittalType('box')} style={transmittalType === 'box' ? { color: '#1975bc' } : { color: '#58595b' }}><Label>routeTitles.boxTransmittals</Label></PrimaryLabel>
        <XDivider width='10px' />
        |
        <XDivider width='10px' />
  
        <PrimaryLabel
          id={'acivityList_button_ResponseDetails'}
          onClick={() => setTransmittalType('batch')}
          style={transmittalType === 'batch' ? { color: '#1975bc' } : { color: '#58595b' }}>
          <Label>forms.batchTransmittals</Label>
        </PrimaryLabel>
      </SubRouteTitle>
    )
  }

  return (
    <MainRouteSubRoutePage
      mainTitle='routeTitles.manageBoxTransmittals'
    // subTitle='routeTitles.myJobs'
    >
      <FlexByRow>
        <HalfScreen>
          <React.Fragment>
            <FlexByRow>
              <BoxTransmittalFilter defaultStatus={defaultActiveJobStatus} activeStatus={transmittalStatuses} selectedData={getSelectedData}/>
            </FlexByRow>
          </React.Fragment>
        </HalfScreen>
      </FlexByRow>
      <VerticalDivider />
      <TransmittalSelection />
      <ViewBoxTransmittalsData FilterData={val} transmittalType={transmittalType} />
    </MainRouteSubRoutePage>
  )
}

export default ViewBoxTransmittals